import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import Notification from '../../Helpers/Notification';
import Helpers from '../../Helpers/Helpers';
import { Link, useNavigate } from "react-router-dom";
import '../../styles/auth.css';
// Import Bootstrap 5.3.3 JavaScript for interactive components
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const Register = ({ title }) => {
    const navigate = useNavigate();
    const helpers = Helpers();
    const [input, setInput] = useState({
        name: '',
        gender: '',
        address: '',
        mobile: '',
        email: '',
        username: '',
        password: '',
        confirmPassword: '',
        type: 'user',
    });

    const [profilePic, setProfilePic] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        document.title = title;
    }, [title]);

    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: false,
        fade: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipeToSlide: true,
        touchMove: true,
        accessibility: true,
        beforeChange: (current, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: true,
                    fade: true,
                    swipeToSlide: true,
                    touchMove: true,
                    touchThreshold: 5,
                    swipe: true,
                    draggable: true,
                    speed: 600,
                    autoplaySpeed: 4000,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    dots: true,
                    fade: true,
                    swipeToSlide: true,
                    touchMove: true,
                    touchThreshold: 3,
                    swipe: true,
                    draggable: true,
                    speed: 500,
                    autoplaySpeed: 4000,
                }
            }
        ]
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value });
    };

    const handleFileChange = (e) => {
        const { files } = e.target;
        if (files[0]) setProfilePic(files[0]);
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        // Validate password confirmation
        if (input.password !== input.confirmPassword) {
            Notification('error', 'Passwords do not match!');
            return;
        }

        setLoading(true);

        const formData = new FormData();
        formData.append('name', input.name);
        formData.append('gender', input.gender);
        formData.append('address', input.address);
        formData.append('mobile', input.mobile);
        formData.append('email', input.email);
        formData.append('username', input.username);
        formData.append('password', input.password);
        formData.append('type', input.type);

        if (profilePic) formData.append('profile_pic', profilePic);

        try {
            const response = await helpers.httpRequest(
                '/astrologer/create',
                'POST',
                formData
            );

            Notification(response.status, response.message);
            setLoading(false);

            if (response.status === 'success') {
                setTimeout(() => {
                    navigate('/login');
                }, 1500);
            }
        } catch (error) {
            setLoading(false);
            Notification('error', 'An unexpected error occurred.');
            console.error('Registration error:', error);
        }
    };

    const carouselSlides = [
        {
            image: "assets/images/Astro_Logo.png",
            title: "Join AstroScope",
            subtitle: "Begin Your Cosmic Journey Today"
        },
        {
            image: "assets/images/Antara.jpg", 
            title: "Antara Awaits",
            subtitle: "Discover Ancient Wisdom & Modern Insights"
        },
        {
            image: "assets/images/Astro_Logo.png",
            title: "Premium Experience",
            subtitle: "Unlock Personalized Astrology Services"
        }
    ];

    return (
        <div className="login-container">
            {/* Carousel Background */}
            <div className="carousel-background">
                <Slider ref={sliderRef} {...settings} className="background-slider">
                    {carouselSlides.map((slide, index) => (
                        <div key={index} className="carousel-slide">
                            <div className="slide-background">
                                <img 
                                    src={slide.image} 
                                    alt={slide.title}
                                    className="slide-image"
                                    loading="eager"
                                />
                                <div className="slide-overlay"></div>
                            </div>
                            <div className="slide-content">
                                <h2 className="slide-title">{slide.title}</h2>
                                <p className="slide-subtitle">{slide.subtitle}</p>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>

            {/* Register Card */}
            <div className="login-card-overlay">
                <div className="login-card register-card-extended">
                    {/* Dual Logo Header */}
                    <div className="dual-logo-header">
                        <div className="logo-container">
                            <img 
                                src="assets/images/Astro_Logo.png" 
                                alt="AstroScope" 
                                className="header-logo primary"
                            />
                            <img 
                                src="assets/images/Antara.jpg" 
                                alt="Antara" 
                                className="header-logo secondary"
                            />
                                                    </div>
                        <div className="brand-text">
                            <h3>AstroScope & Antara</h3>
                            <p>Create Your Cosmic Account</p>
                                        </div>
                                    </div>

                {/* Register Content */}
                    <div className="login-content-section register-content">
                    <div className="welcome-text">
                        <h1>Create Account</h1>
                            <p>Join us and start your spiritual journey</p>
                    </div>

                        <form onSubmit={handleRegister} className="login-form register-form">
                            {/* Row 1: Username and Password */}
                            <div className="form-row">
                        <div className="input-group mb-3">
                            <label htmlFor="username" className="input-label">
                                <i className="fas fa-user label-icon"></i>
                                Username
                            </label>
                            <div className="input-wrapper">
                                                    <input
                                    type="text"
                                    id="username"
                                                        name="username"
                                                        value={input.username}
                                                        onChange={handleChange}
                                    placeholder="Enter your username"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                                    />
                                <div className="input-focus-border"></div>
                            </div>
                                                </div>

                        <div className="input-group mb-3">
                            <label htmlFor="password" className="input-label">
                                <i className="fas fa-lock label-icon"></i>
                                Password
                            </label>
                            <div className="input-wrapper">
                                                    <input
                                    type="password"
                                    id="password"
                                                        name="password"
                                                        value={input.password}
                                                        onChange={handleChange}
                                    placeholder="Enter a strong password"
                                                        minLength="8"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                                    />
                                <div className="input-focus-border"></div>
                            </div>
                                                </div>
                            </div>

                            {/* Row 2: Confirm Password and Full Name */}
                            <div className="form-row">
                                <div className="input-group mb-3">
                                    <label htmlFor="confirmPassword" className="input-label">
                                        <i className="fas fa-lock label-icon"></i>
                                        Confirm Password
                                    </label>
                                    <div className="input-wrapper">
                                        <input
                                            type="password"
                                            id="confirmPassword"
                                            name="confirmPassword"
                                            value={input.confirmPassword}
                                            onChange={handleChange}
                                            placeholder="Confirm your password"
                                                        minLength="8"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                                    />
                                <div className="input-focus-border"></div>
                            </div>
                                                </div>

                        <div className="input-group mb-3">
                            <label htmlFor="name" className="input-label">
                                <i className="fas fa-id-card label-icon"></i>
                                Full Name
                            </label>
                            <div className="input-wrapper">
                                                    <input
                                    type="text"
                                    id="name"
                                                        name="name"
                                                        value={input.name}
                                                        onChange={handleChange}
                                    placeholder="Enter your full name"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                                    />
                                <div className="input-focus-border"></div>
                            </div>
                                                </div>
                                                </div>

                            {/* Row 3: Email and Gender */}
                            <div className="form-row">
                        <div className="input-group mb-3">
                            <label htmlFor="email" className="input-label">
                                <i className="fas fa-envelope label-icon"></i>
                                Email
                            </label>
                            <div className="input-wrapper">
                                                    <input
                                    type="email"
                                    id="email"
                                                        name="email"
                                                        value={input.email}
                                                        onChange={handleChange}
                                    placeholder="Enter your email address"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                                    />
                                <div className="input-focus-border"></div>
                            </div>
                                                </div>

                                <div className="input-group mb-3">
                                    <label htmlFor="gender" className="input-label">
                                        <i className="fas fa-venus-mars label-icon"></i>
                                        Gender
                                    </label>
                                    <div className="input-wrapper">
                                        <select
                                            id="gender"
                                            name="gender"
                                            value={input.gender}
                                            onChange={handleChange}
                                            required
                                            disabled={loading}
                                            className="form-select form-control"
                                        >
                                            <option value="" disabled>Select your gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                            <option value="other">Other</option>
                                        </select>
                                        <div className="input-focus-border"></div>
                                    </div>
                                </div>
                            </div>

                            {/* Row 4: Mobile and Address */}
                            <div className="form-row">
                        <div className="input-group mb-3">
                            <label htmlFor="mobile" className="input-label">
                                <i className="fas fa-mobile-alt label-icon"></i>
                                Mobile
                            </label>
                            <div className="input-wrapper">
                                                    <input
                                    type="tel"
                                    id="mobile"
                                                        name="mobile"
                                                        value={input.mobile}
                                                        onChange={handleChange}
                                    placeholder="Enter your mobile number"
                                                        pattern="^\d{10}$"
                                                        required
                                    disabled={loading}
                                    className="form-input form-control"
                                />
                                <div className="input-focus-border"></div>
                            </div>
                        </div>

                        <div className="input-group mb-3">
                            <label htmlFor="address" className="input-label">
                                <i className="fas fa-home label-icon"></i>
                                Address
                            </label>
                            <div className="input-wrapper">
                                <input
                                    type="text"
                                    id="address"
                                    name="address"
                                    value={input.address}
                                    onChange={handleChange}
                                    placeholder="Enter your address"
                                    required
                                    disabled={loading}
                                    className="form-input form-control"
                                />
                                <div className="input-focus-border"></div>
                                    </div>
                            </div>
                                                </div>

                            {/* Profile Picture Upload */}
                        <div className="input-group mb-4">
                            <label htmlFor="profile_pic" className="input-label">
                                <i className="fas fa-camera label-icon"></i>
                                    Profile Picture (Optional)
                            </label>
                            <div className="file-upload-wrapper">
                                                    <input
                                    type="file"
                                    id="profile_pic"
                                                        name="profile_pic"
                                                        accept="image/*"
                                                        onChange={handleFileChange}
                                    disabled={loading}
                                    className="file-upload-input"
                                                    />
                                <label htmlFor="profile_pic" className="file-upload-label">
                                        <i className="fas fa-cloud-upload-alt file-upload-icon"></i>
                                    {profilePic ? profilePic.name : 'Choose profile picture'}
                                </label>
                                                    {profilePic && (
                                    <div className="file-selected">
                                            <i className="fas fa-check-circle me-2"></i>
                                            {profilePic.name} selected
                                    </div>
                                )}
                            </div>
                        </div>

                            {/* Terms and Conditions */}
                            <div className="form-extras mb-4">
                                <div className="form-check">
                                    <input 
                                        className="form-check-input" 
                                        type="checkbox" 
                                        id="agreeTerms"
                                        required
                                    />
                                    <label className="form-check-label" htmlFor="agreeTerms">
                                        I agree to the <Link to="/terms-and-conditions" className="terms-link">Terms & Conditions</Link> and <Link to="/privacy-policy" className="terms-link">Privacy Policy</Link>
                                    </label>
                            </div>
                        </div>

                        <button 
                            type="submit" 
                            className={`submit-btn btn btn-primary w-100 ${loading ? 'loading' : ''}`}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <div className="spinner-border spinner-border-sm me-2" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    Creating Account...
                                </>
                            ) : (
                                <>
                                    Create Account
                                        <i className="fas fa-user-plus ms-2 btn-arrow"></i>
                                </>
                            )}
                        </button>
                    </form>

                    <div className="signup-prompt text-center">
                        <span>Already have an account? </span>
                            <Link to="/login" className="signup-link">Sign in</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
